import { useContext } from "react";
import styled from "@emotion/styled";
// import cardTextWhiteTick from "../../../Assets/Images/card-text-white-tick.png";
// import cardTextGreenTick from "../../../Assets/Images/card-text-tick.png";
import blueJellyIcon from "../../../Assets/Images/VybogTAL-Icon.svg";
import whiteJellyIcon from "../../../Assets/Images/VybogTAL-Icon.svg";

import { DynamicContext } from "../../../Context/DynamicContext";

const PlanCard = ({
  name,
  subHeader,
  price,
  features,
  highlighted,
  buttonText,
  trialButtonText,
  onTrialClick,
  onPlanClick,
  index,
  isCustom = false,
  isManualBilling = false,
}) => {
  const { subscriptionDetails } = useContext(DynamicContext);
  const isStripeActive =
    subscriptionDetails?.billing_provider === "stripe" &&
    subscriptionDetails?.status === "active";
  const Badge = styled.div`
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    background: ${(props) => {
      switch (props.type) {
        case "trial":
          return "linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)";
        case "current":
          return "linear-gradient(135deg, #FFD700 0%, #FFC400 30%, #FFA500 70%, #FF8C00 100%)";
        default:
          return "#6c63ff";
      }
    }};
    color: ${(props) => (props.type === "current" ? "#8B4513" : "white")};
    padding: 6px 12px;
    border-radius: 25px;
    font-size: 12px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 1.2px;
    box-shadow: ${(props) =>
      props.type === "current"
        ? "0 4px 15px rgba(255, 215, 0, 0.5), 0 2px 5px rgba(0, 0, 0, 0.3)"
        : "0 4px 12px rgba(0, 0, 0, 0.2)"};
    z-index: 10;
    white-space: nowrap;
    min-width: 130px;
    text-align: center;
    border: ${(props) =>
      props.type === "current" ? "1px solid rgba(255, 215, 0, 0.8)" : "none"};
    text-shadow: ${(props) =>
      props.type === "current" ? "0 1px 2px rgba(255, 255, 255, 0.5)" : "none"};
  `;

  const CardContainer = styled.div`
    border: ${(props) =>
      props.highlighted ? "2px solid #6c63ff" : "1px solid #ddd"};
    border-radius: 8px;
    padding: 25px 20px;
    text-align: center;
    width: 23.5%;
    min-width: 280px;
    background-color: ${(props) =>
      props.highlighted ? "#6c63ff" : "var(--body__background)"};
    box-shadow: ${(props) =>
      props.highlighted ? "0px 4px 8px rgba(0, 0, 0, 0.1)" : "none"};
    position: relative;
    display: flex;
    flex-direction: column;
    opacity: 0;
    transform: scale(0.95);
    animation: fadeInScale 0.5s ease-in-out forwards;
    animation-delay: ${(props) => props.index * 0.2}s;
    transition:
      transform 0.3s ease,
      box-shadow 0.3s ease;
    flex-shrink: 0; /* Prevent cards from shrinking */

    @keyframes fadeInScale {
      from {
        opacity: 0;
        transform: scale(0.95);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }

    &:hover {
      transform: scale(1.05);
      box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
    }
    @media (max-width: 768px) {
      width: 280px;
      min-width: 260px;
    }

    @media (max-width: 480px) {
      width: 260px;
      min-width: 240px;
    }
  `;

  const ButtonContainer = styled.div`
    margin-top: auto;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 10px;
  `;

  const Price = styled.div`
    font-size: 25px;
    font-weight: bold;
    color: ${(props) => (props.highlighted ? "#fff" : "#6c63ff")};
    margin-bottom: 0px;
    text-align: justify;
    margin-top: ${(props) => (props.highlighted ? "0px" : "18px")};
    @media (max-width: 900px) {
      font-size: 20px;
    }
  `;

  const SubHeader = styled.div`
    font-size: 12px;
    color: ${(props) =>
      props.highlighted ? "#ffffffc9" : "var(--job-Description_Color)"};
    margin-bottom: 15px;
    text-align: left;
  `;

  const PlanName = styled.div`
    font-size: 22px;
    font-weight: bold;
    color: ${(props) => (props.highlighted ? "#fff" : "#6c63ff")};
    margin-bottom: -2px;
    text-align: left;
    margin-top: 18px;
  `;

  const FeatureList = styled.ul`
    list-style: none;
    padding: 0;
    text-align: left;
    font-size: 14px;
    color: ${(props) =>
      props.highlighted ? "#fff" : "var(--job-Description_Color)"};
    line-height: 1.8;
  `;

  const FeatureListText = styled.li`
    color: ${(props) => {
      if (props.isBold) {
        return props.highlighted ? "#FFD700" : "#4a42d4"; // Gold for highlighted, purple for normal
      }
      return props.highlighted ? "#fff" : "var(--job-Description_Color)";
    }};
    font-weight: ${(props) => (props.isBold ? "bold" : "normal")};
    font-size: ${(props) => (props.isBold ? "15px" : "14px")};

    ${(props) => props.isBold && `position: relative; `}
  `;

  const CardTextImage = styled.img`
    width: 8%;

    @media (max-width: 1024px) {
      width: 3%;
    }

    @media (max-width: 768px) {
      width: 5%;
    }

    @media (max-width: 480px) {
      width: 10%;
    }

    @media (max-width: 320px) {
      width: 12%;
    }
  `;

  const CardTextContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;
    margin-bottom: 10px;
  `;
  const TrialButton = styled.button`
    background-color: transparent;
    color: ${(props) => (props.highlighted ? "#fff" : "#6c63ff")};
    border: 1px solid ${(props) => (props.highlighted ? "#fff" : "#6c63ff")};
    padding: 10px 40px;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover {
      background-color: ${(props) => (props.highlighted ? "#fff" : "#6c63ff")};
      color: ${(props) => (props.highlighted ? "#6c63ff" : "#fff")};
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(108, 99, 255, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  `;

  const StartPlanButton = styled.button`
    background: ${(props) =>
      props.highlighted
        ? "linear-gradient(135deg, #fff 0%, #f8f9fa 100%)"
        : "linear-gradient(135deg, #6c63ff 0%, #4a42d4 100%)"};
    color: ${(props) => (props.highlighted ? "#6c63ff" : "#fff")};
    border: ${(props) =>
      props.highlighted ? "1px solid #fff" : "1px solid #6c63ff"};
    padding: 12px 40px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    transition: all 0.3s ease;
    box-shadow: ${(props) =>
      props.highlighted
        ? "0 4px 12px rgba(255, 255, 255, 0.3)"
        : "0 4px 12px rgba(108, 99, 255, 0.3)"};

    &:hover {
      transform: translateY(-2px);
      box-shadow: ${(props) =>
        props.highlighted
          ? "0 6px 16px rgba(255, 255, 255, 0.4)"
          : "0 6px 16px rgba(108, 99, 255, 0.4)"};
      background: ${(props) =>
        props.highlighted
          ? "linear-gradient(135deg, #f8f9fa 0%, #fff 100%)"
          : "linear-gradient(135deg, #4a42d4 0%, #6c63ff 100%)"};
    }

    &:active {
      transform: translateY(0);
    }

    &:disabled {
      background: ${(props) =>
        props.highlighted
          ? "linear-gradient(135deg, #cccccc 0%, #999999 100%)"
          : "linear-gradient(135deg, #cccccc 0%, #999999 100%)"};
      color: ${(props) => (props.highlighted ? "#fff" : "#666")};
      border: ${(props) =>
        props.highlighted ? "1px solid #cccccc" : "1px solid #cccccc"};
      cursor: not-allowed;
      transform: none;
      box-shadow: none;

      &:hover {
        transform: none;
        box-shadow: none;
        background: ${(props) =>
          props.highlighted
            ? "linear-gradient(135deg, #cccccc 0%, #999999 100%)"
            : "linear-gradient(135deg, #cccccc 0%, #999999 100%)"};
      }
    }
  `;

  const handleTrialClick = () => {
    if (onTrialClick) {
      onTrialClick(name.toLowerCase());
    }
  };

  const handlePlanClick = () => {
    if (onPlanClick) {
      onPlanClick(name.toLowerCase());
    }
  };

  const hasActiveTrial = subscriptionDetails?.status === "trialing";
  const hasActivePlan = subscriptionDetails?.status === "active";
  const isCurrentPlan =
    subscriptionDetails?.plan_name?.toLowerCase() === name.toLowerCase();
  const shouldHighlight = subscriptionDetails?.plan_name
    ? isCurrentPlan
    : highlighted;

  const getBadgeType = () => {
    if (isCurrentPlan) {
      if (hasActiveTrial) {
        return { type: "trial", text: "Free Trial" };
      } else if (hasActivePlan) {
        return { type: "current", text: "Current Plan" };
      }
    }
    return null;
  };

  const badgeInfo = getBadgeType();
  const shouldBeBold = (featureText) => {
    const boldFeatures = [
      "Up to",
      "Vendor management",
      "3rd-party API integration",
      "Users limit based on requirement",
    ];

    return boldFeatures.some(
      (boldFeature) =>
        featureText.includes(boldFeature) || featureText === boldFeature,
    );
  };
  return (
    <CardContainer highlighted={shouldHighlight} index={index}>
      {badgeInfo && <Badge type={badgeInfo.type}>{badgeInfo.text}</Badge>}
      <PlanName highlighted={shouldHighlight}>{name}</PlanName>
      <SubHeader highlighted={shouldHighlight}>{subHeader}</SubHeader>
      <Price highlighted={shouldHighlight}>{price}</Price>
      <div className="brecker"></div>
      <FeatureList>
        {features.map((feature, index) => (
          <CardTextContainer className="cart-text-list" key={index}>
            <CardTextImage
              src={shouldHighlight ? whiteJellyIcon : blueJellyIcon}
              alt="cardTextWhiteTick"
              className="card-text-image"
            />
            <FeatureListText
              highlighted={shouldHighlight}
              isBold={shouldBeBold(feature)}
            >
              {feature}
            </FeatureListText>
          </CardTextContainer>
        ))}
      </FeatureList>
      {!isManualBilling && (
        <ButtonContainer>
          {!isCustom && !hasActiveTrial && !hasActivePlan && (
            <TrialButton
              highlighted={shouldHighlight}
              onClick={handleTrialClick}
            >
              {trialButtonText || "Free Trial"}
            </TrialButton>
          )}
          {isCustom && (
            <StartPlanButton
              highlighted={shouldHighlight}
              onClick={handlePlanClick}
            >
              {buttonText}
            </StartPlanButton>
          )}
          {!isCustom && !isStripeActive && hasActivePlan && !isCurrentPlan && (
            <StartPlanButton
              highlighted={shouldHighlight}
              onClick={handlePlanClick}
            >
              {buttonText}
            </StartPlanButton>
          )}

          {!isCustom && !isStripeActive && hasActiveTrial && (
            <StartPlanButton
              highlighted={shouldHighlight}
              onClick={handlePlanClick}
            >
              {buttonText}
            </StartPlanButton>
          )}
        </ButtonContainer>
      )}
    </CardContainer>
  );
};

export default PlanCard;